import { Injectable } from '@angular/core';
import { FmsVehicle } from '../../models/fms-vehicle';
import { ReservationType, SystemAlerts } from './models/system-alerts';

class AlertInfo {
  private isNewInfo: boolean = true;
  private isValidInfo: boolean = true;
  private isRemovableInfo: boolean = false;
  private vehicleIdentifier: number = undefined;

  constructor(
    private response: SystemAlerts,
    private receivedTime: number
  ) {

  }

  public equals(response: SystemAlerts) : boolean {
    return (this.response.userId === response.userId) && (this.response.historyCreatedAt === response.historyCreatedAt) && (this.response.reservationType === response.reservationType);
  }

  public isSameUserId(userId: number): boolean {
    return this.response.userId == userId;
  }
  public isNew(): boolean {
    return this.isValid() && this.isNewInfo;
  }

  public isValid(): boolean {
    return this.isValidInfo;
  }

  public isRemovable(): boolean {
    return this.isRemovableInfo;
  }

  public getReceivedTime(): number {
    return this.receivedTime;
  }

  public getAlerts(): SystemAlerts {
    return this.response;
  }

  public getTargetVehicleIdentifier(): number {
    return this.vehicleIdentifier;
  }

  public setTargetVehicleIdentifier(id: number): void {
    this.vehicleIdentifier = id;
  }

  public update(validTime: number): void {
    this.isNewInfo = false;
    this.isValidInfo = validTime <= this.receivedTime;
    this.isRemovableInfo = (validTime - 60000) > this.receivedTime;
  }
}

@Injectable()
export class ReservationAlertService {
  private readonly dulationMilliseconds = 60000;
  private alertInfos: AlertInfo[];

  constructor() {
    this.alertInfos = new Array();
  }

  public getAlerts(vehicleId: number, userIds: number[], needsUpdateTargetVehicleIdentifier: boolean): SystemAlerts[] {
    const filtered = this.alertInfos
      .filter((info) => info.isValid() && (vehicleId == info.getTargetVehicleIdentifier() || userIds.find((userId) => info.isSameUserId(userId)) !== undefined));
    if (filtered.length <= 0) {
      return [];
    }
    if (needsUpdateTargetVehicleIdentifier) {
      filtered.forEach((info) => {
        info.setTargetVehicleIdentifier(vehicleId);
      });
    }
    return filtered.map((info) => info.getAlerts());
  }

  public existsNewAlerts(userIds: number[]): boolean {
    return this.alertInfos.find((info) => info.isNew() && userIds.find((userId) => info.isSameUserId(userId)) !== undefined) !== undefined;
  }

  public existsValidNewReservationAlerts(): boolean {
    return this.alertInfos.find((info) => info.isNew() && info.isValid() && info.getAlerts().reservationType == ReservationType.Fixed) !== undefined;
  }

  public existsValidNewCancellationAlerts(): boolean {
    return this.alertInfos.find((info) => info.isNew() && info.isValid() && (info.getAlerts().reservationType == ReservationType.CancelByUser || info.getAlerts().reservationType == ReservationType.CancelByUserRideTimeout)) !== undefined;
  }

  public merge(newAlerts: SystemAlerts[], now: number) : void {
    let keepAlerts = this.alertInfos.filter((info) => newAlerts.find((newAlert) => info.equals(newAlert)) == undefined);
    keepAlerts.forEach((alerts) => alerts.update(now - this.dulationMilliseconds));
    keepAlerts = keepAlerts.filter((alerts) => !alerts.isRemovable());
    const nextInfos = newAlerts.map((alerts) => {
      const foundInfo = this.alertInfos.find((info) => info.equals(alerts));
      if (foundInfo === undefined) {
        const newInfo = new AlertInfo(alerts, now);
        return newInfo;
      }
      foundInfo.update(now - this.dulationMilliseconds);
      return foundInfo;
    });
    this.alertInfos = nextInfos.concat(keepAlerts);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/reservation-alert-service.ts